import { axiosUserRequest, METHOD } from '../api/Requests';

export const getTributesByCity = (id, nacional) => axiosUserRequest(`/RegimeEspecialTributacao/ListarPorMunicipio/${id}/${nacional}`, METHOD.GET);

export const getById = (id) => axiosUserRequest(`/RegimeEspecialTributacao/${id}`, METHOD.GET);
